import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import api from "../services";
import { CustomError } from "../components";

const ShortLinkHandlerProvider = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [showError, setShowError] = useState(false);
  const [errorDetails, setErrorDetails] = useState(null);

  useEffect(() => {
    if (location.pathname.startsWith("/s/")) {
      handleShortLink(location.pathname);
    }
  }, [location.pathname]);

  const handleShortLink = async (pathname) => {
    try {
      const match = pathname.match(/^\/s\/([A-Za-z0-9-_]+)/);
      if (!match) {
        showCustomError("global.invalid_link", "global.link_no_longer_valid");
        return;
      }

      const shortCode = match[1];
      const response = await api.verifyShortLink(shortCode);
      let isExpired;
      let isClickLimitReached;
      const { data, success } = response || {};
      if (!success || !data) throw new Error("Invalid short link");
      if (data.expires_at) {
        const now = dayjs();
        const expiresAt = dayjs(data.expires_at);
        isExpired = expiresAt.isBefore(now);
      }
      if (data.click_count && data.max_clicks) {
        isClickLimitReached = data.click_count >= data.max_clicks;
      }

      if ((isExpired || isClickLimitReached) && data?.status !== "ACTIVE") {
        showCustomError("global.invalid_link", "global.link_no_longer_valid");
        return;
      }

      const longUrl = data.long_url;

      if (
        longUrl.startsWith("http") &&
        !longUrl.includes(window.location.origin)
      ) {
        window.location.href = longUrl;
      } else {
        const relativePath = longUrl.replace(window.location.origin, "");
        window.history.pushState({}, "", relativePath);
      }
    } catch (err) {
      showCustomError("global.invalid_link", "global.link_no_longer_valid");
    }
  };

  const showCustomError = (title, message) => {
    setErrorDetails({ title, message });
    setShowError(true);
  };

  const handleCloseError = () => {
    setShowError(false);
    setErrorDetails(null);
    navigate("/");
  };

  return (
    <>
      {children}
      {showError && errorDetails && (
        <CustomError
          showPopup={true}
          title={errorDetails.title}
          message={errorDetails.message}
          hideRequestSection
          handleTryAgain={handleCloseError}
        />
      )}
    </>
  );
};

export default ShortLinkHandlerProvider;
